import { useApi } from "@utils/useApi";
import {
  SwitchUserContextRequest,
  type SwitchUserContextResponse,
  UserContextClient,
} from "@lib/ShiOneClient";
import { useMutation, useQuery } from "@tanstack/react-query";
import ms from "ms";
import type { SwitcherSelection } from "./storefrontSwitcherData";

export const UserContextQKey = "user-context";

export function useGetUserContext(enabled = true) {
  const api = useApi(UserContextClient);

  return useQuery({
    queryKey: [UserContextQKey],
    queryFn: () => api.getContext(),
    staleTime: ms("30m"),
    enabled,
  });
}

export function useSwitchUserContext() {
  const api = useApi(UserContextClient);

  return useMutation<SwitchUserContextResponse, unknown, SwitcherSelection>({
    mutationFn: (selection) => {
      const request = new SwitchUserContextRequest();
      request.tenantId = selection.tenantId;
      request.storefrontOrgUnitId =
        selection.kind === "storefront" ? selection.orgUnitId : undefined;
      return api.switchContext(request);
    },
  });
}
